import * as React from 'react';

import { ToastContainer, toast} from 'react-toastify'

import { PathwayContainer, PathwaysWrapper, PathwayIcon, CategoryIcon } from './PlexPathways.styles';

import energy from '../../../../assets/images/onboard/energy-icon.svg'
import feelgood from '../../../../assets/images/onboard/feelgood-icon.svg'
import memory from '../../../../assets/images/onboard/memory-icon.svg'
import organized from '../../../../assets/images/onboard/organized-icon.svg'
import performance from '../../../../assets/images/onboard/performance-icon.svg'
import revision from '../../../../assets/images/onboard/revision-icon.svg'
import lock from '../../../../assets/images/onboard/lock-icon.svg'

const icons = {
    "easy": energy,
    "medium":feelgood,
    "hard":memory,
    "very hard": organized,
    "genius": performance,
    "revision": revision,
}
const icons2 = [energy, feelgood, memory, organized,performance, revision];


const difficultyLevels = {
    'easy': 1,
    'medium': 2,
    'hard': 3,
    'very hard': 4,
    'genius': 5
}
interface IProps {
    data?: any;
    onLessonClick?: any;
    history?: any;
    allLessons?: any;
}
interface IState {
    completedLessonsIDs: any;
    loaded: boolean;
}

class PlexPathway extends React.Component<IProps, IState> {
    private ls = window.localStorage;
    constructor(props){
        super(props);
        this.state = {
            completedLessonsIDs: [],
            loaded: false
        }
    }

    public componentDidMount() {
        // this.ls.removeItem('completedlessons');
        const completedLessons = this.ls.getItem('completedlessons');
        if(completedLessons === null) {
            console.info("No Complete lessons");
        }else {
            const completedLessonsIDs1 = JSON.parse(completedLessons);
            this.setState({completedLessonsIDs: completedLessonsIDs1.lessons, loaded: true});
        }
    }
    public onPathwaySelection(lessonName,clickedLesson, difficulty, index){
        const { completedLessonsIDs } = this.state;
        if(index > completedLessonsIDs.length) {
            toast.warn("Complete your current Lesson first!");
        }else {
            this.ls.setItem('currentlesson', lessonName);
            this.props.onLessonClick(clickedLesson, difficulty);
        }
    }

    public isLessonCompleted(lessonid, difficulty) {
        const { completedLessonsIDs } = this.state;
        const found = completedLessonsIDs.find(lesson => lesson.lessonid === `${lessonid}` && lesson.difficulty === `${difficulty}`);
        if(found) {
            return true;
        }else {
            return false;
        }
    }

    // public isNextLesson(lessonid, difficulty, index) {
    //     // compute next lesson
    //     const { data, allLessons } = this.props;
    //     const { completedLessonsIDs } = this.state;
    //     const easy = allLessons[0].length;
    //     const medium = allLessons[1].length;
    //     const hard = allLessons[2].length;
    //     const veryHard = allLessons[3].length;
    //     const genius = allLessons[4].length;


    // }

    public render() {
        const { data } = this.props;
        // console.log(JSON.stringify(data));
        const lessonkey = "Title";
        const lessonid = "id";
        const nextLesson = this.state.completedLessonsIDs.length;
        const lessons = new Array();
        data.lessons.forEach(lesson => {
            lessons.push(lesson);
        })
        lessons.reverse();
        return(
            <PathwayContainer>
                <ToastContainer />
                <CategoryIcon>
                    <div className="icon-wrapper">
                        <img src={memory} alt=""/>
                    </div>
                    <p className="pathway-category">{data["category-name"]}</p>
                </CategoryIcon>
                <PathwaysWrapper>
                    {lessons.map((lesson, index) =>
                        <PathwayIcon key={lesson[lessonid]} onClick={this.onPathwaySelection.bind(this,lesson[lessonkey], lesson[lessonid], difficultyLevels[data["category-name"]], index)}>
                            <div className="icon-wrapper">
                                <img src={ this.isLessonCompleted(lesson[lessonid], difficultyLevels[data["category-name"]]) || index === nextLesson ? icons2[index % 4] : lock } alt="lesson icon" />
                            </div>
                            <p className="lesson-name">{lesson[lessonkey]}</p>
                        </PathwayIcon>
                    )}
                </PathwaysWrapper>
            </PathwayContainer>
        )
    }
}

export default PlexPathway;


// WEBPACK FOOTER //
// ./src/components/OnBoard/Plexing/PlexPathways/PlexPathways.Component.tsx